import { render } from "./owl456Page.vue?vue&type=template&id=0995a0a8"
import script from "./owl456Page.vue?vue&type=script&lang=js"
export * from "./owl456Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__